var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20ZM13 13.172L18.364 7.80711C18.7545 7.41659 19.3876 7.41657 19.778 7.80705C20.1685 8.19749 20.1685 8.83052 19.7781 9.22099L12.7071 16.2928C12.3166 16.6834 11.6834 16.6834 11.2929 16.2929L4.22186 9.22186C3.83143 8.83143 3.83149 8.19829 4.22178 7.80772C4.61224 7.41698 5.24573 7.41667 5.63636 7.80724L11 13.17V3C11 2.44771 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V13.172Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/icon-download-white.7280566dd50e8ab3d4f2840b22c64486.svg";
export { ForwardRef as ReactComponent };